import React from 'react';
import { ConnectedPositionElement } from '@models/applicants';
import styles from '@components/app-components/applicant/applicant-connection-card/ApplicantConnectionCard.module.scss';
import PublishedIcon from '@assets/svgs/green-dot-icon.svg';
import CircledCheckIcon from '@assets/svgs/circled-check-icon.svg';
import OpenIcon from '@assets/svgs/open-position-icon.svg';
import ClosedIcon from '@assets/svgs/grey-small-square-icon.svg';
import PinIcon from '@assets/svgs/pin-icon.svg';
import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';

type ApplicantCorrelationCardProps = {
  position: ConnectedPositionElement;
};

require('dayjs/locale/el');
dayjs.locale('el');

const ApplicantConnectionCard: React.FC<ApplicantCorrelationCardProps> = ({ position }) => {
  const { t: translate } = useTranslation('applicant');

  const positionIcon = (status: string) => {
    if (status === 'published') {
      return <PublishedIcon data-testid="green-dot-icon" />;
    }
    if (status === 'inactive') {
      return <ClosedIcon data-testid="grey-square-icon" />;
    }
    return <OpenIcon data-testid="purple-cyrcle-icon" />;
  };

  const renderPositionAndLocation = () => {
    if (position.location && position.code) {
      return `${position.location} · ${position.code}`;
    } else if (position.location && position.code === null) {
      return position.location;
    } else if (position.location === null && position.code) {
      return position.code;
    }
    return '';
  };

  const renderStepText = () => {
    if (position.hired) {
      return translate('hired');
    }
    if (position.rejected === 'rejected') {
      return translate('rejected');
    }
    return position.step;
  };

  return (
    <div className={styles.wrapConnectionCard} data-testid="connection-card">
      <div className={styles.topCard}>
        <div>
          <>
            {positionIcon(position.status)}
            <span
              className={`small-body-text ${styles.positionTitle} ${
                position.applied ? styles.applied : styles.connected
              }`}
            >
              {position.title}
            </span>
          </>
          <>
            <div className={`small-body-text ${styles.positionLocation}`}>{renderPositionAndLocation()}</div>
          </>
        </div>
        <div className={`small-body-text ${styles.applicantStep}`}>{renderStepText()}</div>
      </div>
      <div className={styles.wrapConnectionInfo}>
        <div>
          <div className={`main-body-text ${styles.connectionInfoText}`}>
            {position.applied ? translate('application_info') : translate('correlated_card')}
          </div>
          <div className={`main-body-text ${styles.connectionDate}`}>
            {position.connectedDate ? dayjs(new Date(position.connectedDate)).format('DD MMM YYYY').toUpperCase() : ''}
          </div>
        </div>
        <div>{position.applied ? <CircledCheckIcon data-testid="document-red-icon" /> : <PinIcon />}</div>
      </div>
    </div>
  );
};

export default ApplicantConnectionCard;
